type MetadataItem = { key: string; value?: unknown; type?: string }

type OptionPayload = {
  id?: unknown
  label?: unknown
  value?: unknown
  metadata?: MetadataItem[] | string
}

export const flattenObj = (payload: OptionPayload): Record<string, unknown> => {
  // might come from cache update, so test if its a string
  const metadataRaw = payload.metadata
  const metadata: MetadataItem[] =
    typeof metadataRaw === 'string'
      ? (JSON.parse(metadataRaw || '[]') as MetadataItem[]).filter(
          (m) => m.type === 'user',
        )
      : (metadataRaw as MetadataItem[] | undefined)?.filter(
          (m) => m.type === 'user',
        ) ?? []

  const metadataObj = metadata.reduce<Record<string, unknown>>(
    (acc, curr) => {
      acc[curr.key] = curr.value
      return acc
    },
    {},
  )

  return {
    id: payload.id,
    label: payload.label,
    value: payload.value,
    ...metadataObj,
  }
}
